import React, { useState } from 'react';
import { motion, useAnimation } from 'framer-motion'
import { Waypoint } from 'react-waypoint'

import Capability from './Capability';

const CapabilityList = (props) => {
  const CAPABILITIES = [
    {
      heading: 'Lorem ipsum amet',
      description: 'Phasellus convallis elit id ullam corper amet et pulvinar. Duis aliquam turpis mauris, sed ultricies erat dapibus.',
      iconClass: 'fa-code',
    },
    {
      heading: 'Morem ipsum amet',
      description: 'Phasellus convallis elit id ullam corper amet et pulvinar. Duis aliquam turpis mauris, sed ultricies erat dapibus.',
      iconClass: 'fa-lock',
    },
    {
      heading: 'Dorem ipsum amet',
      description: 'Phasellus convallis elit id ullam corper amet et pulvinar. Duis aliquam turpis mauris, sed ultricies erat dapibus.',
      iconClass: 'fa-cog',
    },
    {
      heading: 'Forem ipsum amet',
      description: 'Phasellus convallis elit id ullam corper amet et pulvinar. Duis aliquam turpis mauris, sed ultricies erat dapibus.',
      iconClass: 'fa-desktop',
    },
    {
      heading: 'Corem ipsum amet',
      description: 'Phasellus convallis elit id ullam corper amet et pulvinar. Duis aliquam turpis mauris, sed ultricies erat dapibus.',
      iconClass: 'fa-chain',
    },
    {
      heading: 'Norem ipsum amet',
      description: 'Phasellus convallis elit id ullam corper amet et pulvinar. Duis aliquam turpis mauris, sed ultricies erat dapibus.',
      iconClass: 'fa-diamond',
    },
  ]

	const [capabilities] = useState(CAPABILITIES);

  const controls = useAnimation()
  const variants = {
		visible: i => ({
			opacity: 1,
			transition: {
				delay: i * 0.3,
			},
		}),
		hidden: { opacity: 0 },
  }
  const container = {
		hidden: { opacity: 1, scale: 1 },
		visible: {
			opacity: 1,
			scale: 1,
			transition: {
				delay: 0.3,
				when: 'beforeChildren',
				staggerChildren: 0.1,
			},
		},
	}

	function startAnimation() {
		controls.start('visible')
	}
  return (
			<Waypoint
				onEnter={() => startAnimation()}
				bottomOffset={500}
			>
				<motion.ul
					variants={container}
					initial="hidden"
					animate={controls}
				>
				{
					capabilities.map((capability, i) => (
						<motion.li
						custom={i}
						animate={controls}
						variants={variants}
						key={capability.heading}
						>
							<span className={`icon major ${capability.iconClass}`} />
							<h3>{capability.heading}</h3>
							<p>{capability.description}</p>
						</motion.li>
					))
				}
				</motion.ul>
			</Waypoint>
	)
}

export default CapabilityList;
